<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  watch: {
    $route(to, from) {
      this.img();
    }
  },
  created() {
    this.img();
  },
  methods: {
    img() {
      //这个组件的作用，当不是pc访问的时候，把样式直接改变成gongyiimg_show
      console.log(sessionStorage.getItem("laiyuan"));
      if (sessionStorage.getItem("laiyuan") != "pc") {
        const arr = document.querySelectorAll(".gongyiimg");
        if (arr) {
          arr.forEach(val => {
            val.className = "gongyiimg_show";
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/chanpin/components/gongyiimg.vue